// cannot use programIdentifier from route
// because this code runs before the current route is entered
export default (ctx) => {
  if (!ctx.store.state.auth.selectedProgram) return
  if (ctx.store.getters['auth/isSelectedProgramWithPuzzle']) return

  ctx.redirect(ctx.store.getters['auth/programBaseRoute'])
}
